var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import FTLPaginationButtonStyles from "../styles/FTLPaginationButtonStyles.styles";
import clsx from "clsx";
import { FTLButton } from "../../../..";
export default React.forwardRef((_a, ref) => {
    var { paginationType = "default", isSelected = false, className } = _a, otherProps = __rest(_a, ["paginationType", "isSelected", "className"]);
    const { defaultPaginationButton, iconPuginationButton } = FTLPaginationButtonStyles();
    if (paginationType === "default") {
        return (React.createElement(FTLButton, Object.assign({ ref: ref, isSelected: isSelected, color: "secondary", className: clsx(defaultPaginationButton, className) }, otherProps)));
    }
    else {
        return (React.createElement(FTLButton, Object.assign({ ref: ref, isSelected: isSelected, color: "secondary", className: clsx(iconPuginationButton, className) }, otherProps)));
    }
});
//# sourceMappingURL=FTLPaginationButton.js.map